<div class="main" fxLayout="column">
  <mat-dialog-content>
    <p><strong>{{data.content}}</strong></p>
  </mat-dialog-content>
  <div class="buttondiv" fxLayout="row" fxFlexAlign="stretch">
    <button class="yesButton" fxFlexAlign="flex-start" (click)="Confirm()">{{data.trueOption | i18next }}</button>
    <button class="noButton" fxFlexAlign="flex-end" (click)="Discline()">{{data.falseOption | i18next }}</button>
  </div>
</div>
